import { render, staticRenderFns } from "./AuthorizedDevicesPage.vue?vue&type=template&id=17583854&scoped=true&"
import script from "./AuthorizedDevicesPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizedDevicesPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedDevicesPage.vue?vue&type=style&index=0&id=17583854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17583854",
  null
  
)

export default component.exports